import { commonActions } from '../../global-store/subjects/common';

import { VIDEO_PLAYER_STATUS } from './constants';

/**
 * Check Video Carousel Player status and position
 * @param {*} videoPlayer player instance
 */
export const initVideoCarouselListeners = (videoPlayer) => {
  Object.keys(VIDEO_PLAYER_STATUS)
    .filter((statusKey) => VIDEO_PLAYER_STATUS[statusKey] !== VIDEO_PLAYER_STATUS.INITIAL)
    .forEach((statusKey) => {
      videoPlayer.on(VIDEO_PLAYER_STATUS[statusKey], () => {
        commonActions.setVideoCarouselStatus(VIDEO_PLAYER_STATUS[statusKey]);
      });
    });
};

// Create the Sky Players Manager instance as singleton
export const createSkyPlayersManager = () => ({
  instance: null,
  init() {
    if (!this.instance) {
      this.instance = new window.SkyPlayersManager({
        async: true,
        visiblethreshold: 75,
      });
    }
    return this.instance;
  },
});
